export default __webpack_public_path__ + "static/media/Review_Icon.9b2754f3.svg";